import { useEffect, useRef } from 'react';

import { Modal, Typography } from 'enable-ui';
import qrCode from 'qr-creator';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { downloadQRCode } from 'modules/calendar/helpers';
import {
  ButtonDownload,
  ButtonDownloadContainer,
  ModalContainer,
  QRCodeContainer,
} from 'modules/calendar/styles/event';

import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';

import { COLOR } from 'constants/color';

export const QRCode = ({ value, size = 240 }: { value: string; size?: number }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current) {
      qrCode.render(
        { text: value, radius: 0.5, ecLevel: 'H', fill: '#000', size, background: '#fff' },
        canvasRef.current,
      );
    }
  }, [value, size]);

  return <canvas ref={canvasRef} />;
};

interface QRCodeModalProps {
  value: string;
}

const QRCodeModal = ({ value }: QRCodeModalProps) => {
  const qrCodeRef = useRef<HTMLDivElement>(null);

  return (
    <ModalContainer>
      <Modal
        header={
          <Typography variant="h4" weight={500} color={COLOR.surfaceNeutralBold['neutral-11']}>
            Check-in QR
          </Typography>
        }
        modalKey={MODAL_KEY.QR_CODE}
        footer={<></>}
      >
        <Typography variant="body-2" color={COLOR.surfaceNeutralBold['neutral-11']}>
          Show this QR code to clients for easy event check-in via scanning
        </Typography>

        <QRCodeContainer ref={qrCodeRef}>
          <QRCode size={240} value={value} />
        </QRCodeContainer>

        <ButtonDownloadContainer onClick={downloadQRCode(qrCodeRef)}>
          <ButtonDownload>
            <DownloadIcon />
            Download
          </ButtonDownload>
        </ButtonDownloadContainer>
      </Modal>
    </ModalContainer>
  );
};

export default QRCodeModal;
